var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGuidecenter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12 20.659a8.692 8.692 0 1 1 0-17.384 8.692 8.692 0 1 1 0 17.384m0-.75a7.908 7.908 0 1 1 0-15.817 7.908 7.908 0 0 1 0 15.817m6.516-8.375l-.81.468.81.467a6.534 6.534 0 0 1-6.066 6.048l-.45-.78-.45.78a6.534 6.534 0 0 1-6.067-6.07L6.257 12l-.774-.446a6.533 6.533 0 0 1 6.063-6.07l.454.785.454-.785a6.533 6.533 0 0 1 6.062 6.05M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm-1.079-8.92l1.51 3.576 3.391-8.478-8.479 3.39 3.578 1.511z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuidecenter);
export default __webpack_public_path__ + "static/media/guidecenter.1db0b6520457071ad4bc2349ce315bf9.svg";
export { ForwardRef as ReactComponent };